import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { IdentityService } from 'app/services/authentication/identity.service';

@Directive({
  selector: '[hasAccess]'
})
export class HasAccessDirective {

  private permissions: (string[] | string);

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private _identityService: IdentityService,
  ) {
  }

  ngOnInit() {
    this.updateView();
  }

  @Input()
  set hasAccess(val) {
    this.permissions = val;
    this.updateView();
  }

  @Input() hasAccessElse: TemplateRef<any>;

  private updateView() {
    this.viewContainer.clear();
    if (this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.hasAccessElse) {
      this.viewContainer.createEmbeddedView(this.hasAccessElse);
    }
  }

  private checkPermission() {
    return this.isHasAccess(this.permissions);
  }

  public isHasAccess(access: (string[] | string)) {
    let hasPermission = false;
    if (this._identityService.permission && access) {
      if (typeof access === 'string') {
        hasPermission = this._identityService.access.some(x => x.toUpperCase() === String(access).toUpperCase());
      } else if (Array.isArray(access)) {
        hasPermission = access.some(checkPermission =>
          this._identityService.access.some(x => x.toUpperCase() === checkPermission.toUpperCase())
        );
      }
    }

    return hasPermission;
  }
}
